import React from 'react';
import { FbitsLogin } from '../components/FbitsLogin';

export function Login() {
	return <FbitsLogin />;
}
